import { useRrhh } from "../../../shared/context/rrhhContext"
import { Box, TextField, Tooltip, IconButton, LinearProgress } from "@mui/material"
import { Refresh as RefreshIcon } from "@mui/icons-material"
import { useState, useEffect } from "react"
import { useTaskContext } from '../../../shared/context/taskContext'
import { useUtiles } from '../../../shared/context/utilesContext'

export default function SelectAssignedOTComponent() {
    const { rrhhByName, loadingGetRrhhByName, getRrhhByName } = useRrhh()
    const { setOtWithTaskPending } = useTaskContext()
    const { toogleOpenSilder } = useUtiles()
    const handleSearch = (e) => {
        getRrhhByName({ name: e.target.value, user_task_attender: true })
    }


    const handleSelectRrhh = (rrhh) => {
        setOtWithTaskPending(prev => ({ ...prev, assigned_to: rrhh }))
        toogleOpenSilder(null, 500, null)
    }

    useEffect(() => {
        getRrhhByName({ user_task_attender: true })
    }, [])
    return (
        <Box sx={{ padding: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <TextField fullWidth placeholder="Escribe para buscar" size="small" onChange={handleSearch} />
                <Tooltip title="Refrescar">
                    <IconButton size="small" onClick={() => getRrhhByName({ user_task_attender: true })}>
                        <RefreshIcon />
                    </IconButton>
                </Tooltip>
            </Box>
            {loadingGetRrhhByName && <LinearProgress />}
            <Box sx={{ mt: 2, maxHeight: '70vh', overflow: 'auto' }}>
                {rrhhByName.map((rrhh) => (
                    <Box 
                        key={rrhh.id}   
                        onClick={() => handleSelectRrhh(rrhh)}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            p: 1.5,
                            mb: 1,
                            borderRadius: 1,
                            boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
                            bgcolor: 'background.paper',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                boxShadow: '0 4px 8px rgba(0,0,0,0.12)',
                                transform: 'translateY(-2px)'
                            },
                            cursor: 'pointer'
                        }}
                    >
                        <Box sx={{ 
                            mr: 2,
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: 'primary.light',
                            color: 'white',
                            overflow: 'hidden'
                        }}>
                            {rrhh.avatar ? (
                                <img 
                                    src={rrhh.avatar} 
                                    alt={rrhh.fullName}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            ) : (
                                <Box sx={{ fontSize: 18 }}>
                                    {rrhh.fullName.charAt(0).toUpperCase()}
                                </Box>
                            )}
                        </Box>
                        <Box sx={{ 
                            display: 'flex', 
                            flexDirection: 'column'
                        }}>
                            <Box sx={{ fontWeight: 500 }}>
                                {rrhh.fullName}
                            </Box>
                            {rrhh.position && (
                                <Box sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>
                                    {rrhh.position}
                                </Box>
                            )}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}